<template>
  <div :key="`main-${mainKey}`">
    <b-card class="py-2 px-2 mt-2" no-body data-cy="panelFiltroHoteles">
      <h6 class="text-center ">
        Filtrar
      </h6>
      <b-row>
        <b-col cols="12" class="py-2">
          <b-link
            href="javascript:void(0)"
            @click="OrderCollapse = !OrderCollapse"
            class="text-dark"
            aria-controls="categorias"
            :aria-expanded="OrderCollapse ? 'true' : 'false'"
            >Ordenar</b-link
          >
          <b-collapse id="categorias" class="mt-2" v-model="OrderCollapse">
            <v-select :items="filtro.ordenamiento" v-model="filtro.orderBy" solo></v-select>
          </b-collapse>
          <hr />
        </b-col>
        <b-col cols="12" class="py-2">
          <b-link
            href="javascript:void(0)"
            @click="CategoriaCollapse = !CategoriaCollapse"
            class="text-dark"
            aria-controls="categorias"
            :aria-expanded="CategoriaCollapse ? 'true' : 'false'"
            >Categorias</b-link
          >
          <b-collapse id="categorias" class="mt-2" v-model="CategoriaCollapse">
            <ul class="ul-not-dot-as">
              <li v-for="(c, index) in filtro.categorias" :key="`cat-${index}`">
                <b-form-checkbox
                  :id="'checkbox' + index"
                  :name="'checkbox' + index"
                  v-model="c.activo"
                  :key="`key-ct-${index}`"
                  @change="updateFiltro"
                  :disabled="filtro.categorias.length === 1"
                >
                  <span v-if="c.estrella > 0 && c.estrella <= 5">
                    <span v-for="(e, indexe) in toInteger(c.estrella)" v-bind:key="indexe">
                      <v-icon class="hotel-star" small color="orange">fas fa-star</v-icon>
                    </span>
                    ({{ c.cantidad }})
                  </span>
                  <span v-else class="font-weight-light">
                    {{ getNombreCategoria(c.estrella) }} ({{ c.cantidad }})
                  </span>
                </b-form-checkbox>
              </li>
            </ul>
          </b-collapse>
          <hr />
        </b-col>
        <b-col cols="12" class="py-2" v-if="filtro.planes.length > 0">
          <b-link
            href="javascript:void(0)"
            @click="PlanesCollapse = !PlanesCollapse"
            class="text-dark"
            aria-controls="planes"
            :aria-expanded="PlanesCollapse ? 'true' : 'false'"
            >Planes de comida</b-link
          >
          <b-collapse id="planes" class="mt-2" v-model="PlanesCollapse">
            <ul class="ul-not-dot-as">
              <li v-for="(c, index) in filtro.planes" :key="`pla-${index}`">
                <b-form-checkbox
                  :id="'checkbox-pl' + index"
                  :name="'checkbox-pl' + index"
                  v-model="c.activo"
                  :key="`key-pl-${index}`"
                  :disabled="filtro.planes.length < 2"
                  @input="updateFiltro"
                >
                  <span class="font-weight-light">
                    {{ c.nombre }}
                  </span>
                </b-form-checkbox>
              </li>
            </ul>
          </b-collapse>
          <hr />
        </b-col>
        <b-col cols="12" class="py-2" v-if="filtro.pases.length > 0">
          <b-link
            href="javascript:void(0)"
            @click="PasesCollapse = !PasesCollapse"
            class="text-dark"
            aria-controls="pases"
            :aria-expanded="PasesCollapse ? 'true' : 'false'"
            >Pases</b-link
          >
          <b-collapse id="pases" class="mt-2" v-model="PasesCollapse">
            <ul class="ul-not-dot-as">
              <li v-for="(c, index) in filtro.pases" :key="`pas-${index}`">
                <b-form-checkbox
                  :id="'checkbox-pas' + index"
                  :name="'checkbox-pas' + index"
                  v-model="c.activo"
                  :key="`key-pas-${index}`"
                  :disabled="filtro.pases.length < 2"
                  @input="updateFiltro"
                >
                  <span class="font-weight-light">
                    {{ c.nombre }}
                  </span>
                </b-form-checkbox>
              </li>
            </ul>
          </b-collapse>
          <hr />
        </b-col>
        <b-col cols="12" class="py-2">
          <b-link
            href="javascript:void(0)"
            @click="preciosCollapse = !preciosCollapse"
            class="text-dark"
            aria-controls="precios"
            :aria-expanded="preciosCollapse ? 'true' : 'false'"
            >Rango de precios</b-link
          >
          <b-collapse id="precios" class="mt-2" v-model="preciosCollapse">
            <vue-slider
              v-model="filtro.slider.value"
              :enable-cross="false"
              :min="filtro.slider.min"
              :max="filtro.slider.max"
              :lazy="true"
            ></vue-slider>
            <small> Minimo: {{ filtro.slider.value[0] }} </small>
            <small class="float-right"> Maximo: {{ filtro.slider.value[1] }} </small>
          </b-collapse>
          <hr />
        </b-col>
        <b-col cols="12" class="py-2">
          <b-link
            href="javascript:void(0)"
            @click="hotelCollapse = !hotelCollapse"
            class="text-dark"
            aria-controls="hotel"
            :aria-expanded="hotelCollapse ? 'true' : 'false'"
            >Hotel</b-link
          >
          <b-collapse id="hotel" class="mt-2" v-model="hotelCollapse">
            <v-autocomplete
              multiple
              :items="filtro.hoteles"
              solo
              color="blue-grey lighten-2"
              label="Destino"
              item-text="nombre"
              item-value="id"
              clearable
              dense
              @change="selectedHotel"
              chips
            >
              <template v-slot:label>
                <small>
                  Escriba el hotel
                </small>
              </template>
              <template v-slot:selection="data">
                <small>
                  {{ data.item.nombre | truncateString(39) }}
                </small>
              </template>
              <template v-slot:item="data">
                <div>
                  <template>
                    <v-list-tile-content>
                      <v-list-tile-title background-color="black">
                        {{ data.item.nombre }}
                      </v-list-tile-title>
                    </v-list-tile-content>
                  </template>
                </div>
              </template>
              <template slot="no-data">
                <span class="text-center">
                  Destino no encontrado
                </span>
              </template>
            </v-autocomplete>
          </b-collapse>
          <hr />
        </b-col>
        <b-col cols="12">
          <v-btn type="submit" block color="primary" dark large class="mt-0" @click="filtrar(filtro)">Aplicar</v-btn>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
// @ is an alias to /src
// Este componente es llamado desde ResultadoHoteles.vue y está
import VueSlider from "vue-slider-component"
import "vue-slider-component/theme/default.css"
import { mapGetters } from "vuex"
export default {
  name: "filtroHoteles",
  props: ["data"],
  components: {
    VueSlider
  },
  mounted() {
    this.filtrar(this.filtro)
  },
  created() {
    // console.log(JSON.parse(JSON.stringify(this.data)));
  },
  activated() {},
  data() {
    return {
      mainKey: 0,
      OrderCollapse: true,
      CategoriaCollapse: true,
      hotelCollapse: true,
      preciosCollapse: true,
      PlanesCollapse: true,
      PasesCollapse: true,
      tiempo: 0
    }
  },
  methods: {
    toInteger(valor) {
      if (valor === "") {
        return 0
      }

      return parseInt(valor)
    },
    selectedHotel(hoteles) {
      this.filtro.hoteles = hoteles
    },
    filtrar(filtro) {
      window.scrollTo(0, 0)
      this.$store.dispatch("app/setLatBus", false)
      var _this = this
      this.tiempo = 1000
      this.$store.dispatch("filtroHoteles/setFiltrando", true)
      setTimeout(function() {
        _this.$store.dispatch("filtroHoteles/filtrar", filtro)
        _this.$nextTick(function() {
          this.$store.dispatch("filtroHoteles/setFiltrando", false)
        })
      }, this.tiempo)
    },
    getNombreCategoria(valor) {
      if (valor == 0) {
        return "No específica"
      }
      let nombre = null
      try {
        const finded = this.formConfig.categorias.find(ct => {
          if (ct.alt === valor) {
            return true
          }
          if (ct.value === valor) {
            return true
          }
          return false
        })
        if (finded == undefined) {
          return
        }
        nombre = finded.text
      } catch (e) {
        console.log(e)
      }
      return nombre
    },
    async updateFiltro() {
      await this.$store.commit("filtroHoteles/mutFiltro", this.filtro)
      this.mainKey = Math.random()
    }
  },
  computed: {
    ...mapGetters("app", {
      formConfig: "getFormConfigHtl"
    }),
    filtros: {
      get() {
        return this.$store.getters["filtroHoteles/getFiltros"]
      },
      set(value) {
        console.log("mut")
        this.$store.commit("filtroHoteles/mutFiltro", value)
        //this.$store.dispatch("filtroHoteles/mutFiltro", value);
      }
    },
    filtro() {
      if (this.filtros.slider != undefined) {
        return this.filtros
      }
      return {
        slider: {
          min: this.filtros.rangoPrecios.min,
          max: this.filtros.rangoPrecios.max,
          value: [this.filtros.rangoPrecios.min, this.filtros.rangoPrecios.max]
        },
        categorias: JSON.parse(JSON.stringify(this.filtros.categorias)),
        hoteles: [],
        planes: JSON.parse(JSON.stringify(this.filtros.planes)),
        pases: JSON.parse(JSON.stringify(this.filtros.tickets)),
        orderBy: 0,
        ordenamiento: this.filtros.ordenamiento
      }
    }
  }
}
</script>
<style scoped>
.input-inside {
  background: white;
  font-size: 11px;
}
</style>
